import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=774e8a50&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=774e8a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e8a50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774e8a50')) {
      api.createRecord('774e8a50', component.options)
    } else {
      api.reload('774e8a50', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=774e8a50&scoped=true&", function () {
      api.rerender('774e8a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8QsvB6paVxk0p/JS/comp/GuestBox.vue"
export default component.exports